import { AfterContentInit, Component, ContentChildren, Input, OnChanges, QueryList, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { SoldoFieldErrorComponent } from '../soldo-field-error/soldo-field-error.component';

@Component({
    selector: 'soldo-field-layout',
    templateUrl: './soldo-field-layout.component.html',
    styleUrls: ['./soldo-field-layout.component.scss']
})
export class SoldoFieldLayoutComponent implements OnChanges, AfterContentInit {
    @ContentChildren(SoldoFieldErrorComponent) errorMessageComponents: QueryList<SoldoFieldErrorComponent>;

    @Input() cypressSelector: string;
    @Input() fieldName: string;
    @Input() label: string;
    @Input() control: AbstractControl;
    @Input() hint: string;
    @Input() useTooltip: boolean = false;
    @Input() tooltipPosition: string = 'top right';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['control']) {
            this.control.statusChanges.subscribe(this.evaluateErrorVisibility);
            if (this.errorMessageComponents) {
                this.evaluateErrorVisibility();
            }
        }
    }

    ngAfterContentInit(): void {
        this.evaluateErrorVisibility();
    }

    private readonly evaluateErrorVisibility = () => {
        const errors = this.control.errors || {};
        this.errorMessageComponents.forEach(emc => {

            if (this.control instanceof UntypedFormGroup) {
                const formGroup = <UntypedFormGroup>this.control;
                Object.keys(this.control.controls).forEach(fgControlKey => {
                    if (formGroup.controls[fgControlKey].errors !== null) {
                        Object.keys(formGroup.controls[fgControlKey].errors).forEach(errorKey => {
                            errors[`${fgControlKey}-${errorKey}`] = true;
                        });
                    }
                });
            }
            emc.active = Boolean(errors[emc.errorName]);
        });
    };
}
